import { render, staticRenderFns } from "./SectionWhatXID.vue?vue&type=template&id=a20315ce&scoped=true"
import script from "./SectionWhatXID.vue?vue&type=script&lang=ts"
export * from "./SectionWhatXID.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhatXID.vue?vue&type=style&index=0&id=a20315ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20315ce",
  null
  
)

export default component.exports